// Libraries
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
// Data
import { dialogerActions } from './useDialogerStore.action';
import { initialState } from './useDialogerStore.state';
// Types
import { DialogerStore } from './useDialogerStore.types';

/**
 * Creates and configures the Dialoger states.
 */
export const useDialogerStore = create(
  immer<DialogerStore>((set) => ({
    ...initialState,
    ...dialogerActions(set),
  }))
);
